import { IViacepAddress } from '@/store/ducks/viacep/type';

import { IAddressValues } from '../resources/components/global/address/components/types';
import api from '../services/api';

export interface IAddressResponse {
  id: number;
  street: string;
  number: string;
  neighborhood: string;
}

export const getAddresses = async (clientId: number) =>
  api.get<void, IAddressResponse[]>(`/clients/${clientId}/addresses`);

export const create = async (address: IAddressValues) =>
  api.post<IAddressValues, IAddressResponse>('/addresses', { ...address });

export const viaCepSearch = async (zipcode: string) => {
  const response = await api.get<IViacepAddress>(`/viacep/${zipcode}`);

  return response;
};
